// Keep in sync with MIN_INDEXABLE_TAG_JOBS in backend/api/api/routers/sitemap.py.
export const MIN_INDEXABLE_JOBS = 5;
